import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { AmountInput } from "./InputAmount";
import { useFormContext } from "react-hook-form";
import { common, input } from "../../../../../../i18n";

interface Props {
  activityType: string;
}

// Map เฉพาะกลุ่มที่มีแค่ AmountInput ตัวเดียว เพื่อดึง i18n key ให้ถูกต้องตามเดิม
const amountLabelMap: Record<string, { label: string; info: string }> = {
  Energy: { label: "Amount-of-Energy", info: "Amount-of-Energy" },
  Fuel: { label: "amount-of-fuel", info: "amount-of-fuel" },
  FireExtinguishing: {
    label: "Amount-of-Fire-Extinguishing",
    info: "Amount-of-Fire-Extinguishing-Description",
  },
  Fertilizer: {
    label: "Amount-of-Key-Substance",
    info: "Amount-of-Key-Substance",
  },
  Water: { label: "Amount-of-Water", info: "Amount-of-Water" },
  OtherFugitiveEmissions: {
    label: "Amount-of-OtherFugitiveEmission",
    info: "Amount-of-OtherFugitiveEmission-Description",
  },
  Refrigerants: {
    label: "Amount-of-Refrigerants",
    info: "Amount-of-Refrigerants-Description",
  },
  CapitalGoods: { label: "Amount", info: "Amount" },
};

const SimpleAmountInput = ({ activityType }: Props) => {
  const { t } = useTranslation([common, input], { nsMode: "fallback" });
  const { control } = useFormContext();
  const config = amountLabelMap[activityType] || {
    label: "Amount",
    info: "Amount",
  };

  return (
    <Grid item xs={12} md={6}>
      <AmountInput
        label={t(config.label)}
        info={t(config.info)}
        control={control}
      />
    </Grid>
  );
};

export default SimpleAmountInput;
